import { useEffect, useState } from 'react';

const ENTRANCE_STAGE_DELAYS_MS = [400, 800, 1000, 1300, 1600];

/**
 * Staged hero entrance timing for orchestrating first-view content reveals.
 */
export const useHeroEntrance = () => {
    const [stage, setStage] = useState(0);

    useEffect(() => {
        const timers = ENTRANCE_STAGE_DELAYS_MS.map((delay, index) =>
            window.setTimeout(() => {
                setStage(index + 1);
            }, delay),
        );

        return () => {
            timers.forEach((timer) => window.clearTimeout(timer));
        };
    }, []);

    return stage;
};
